var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "r-item-page" },
    [
      _c("ac-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.items,
          "item-class": _vm.row_class,
          "sort-by": "key.string",
          "item-key": "key.value",
          "fixed-header": "",
          "footer-props": _vm.footer,
          "items-per-page": 50,
          height: _vm.winsize.height - 145,
          search: _vm.search,
          "can-select": (item) => !_vm.row_readonly(item),
          "can-delete": (item) => !_vm.row_readonly(item),
          "remove-bulk": _vm.bulkRemove,
          "bulk-mode": _vm.bulkMode,
          title: "Items",
        },
        on: {
          "update:items": function ($event) {
            _vm.items = $event
          },
          "update:search": function ($event) {
            _vm.search = $event
          },
          "update:bulkMode": function ($event) {
            _vm.bulkMode = $event
          },
          "update:bulk-mode": function ($event) {
            _vm.bulkMode = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  "v-btn",
                  {
                    staticClass: "ma-2",
                    attrs: { color: "primary" },
                    on: { click: _vm.row_create },
                  },
                  [_vm._v(" New Item ")]
                ),
                _c(
                  "v-btn",
                  {
                    staticClass: "ma-2",
                    attrs: { color: "accent" },
                    on: { click: _vm.show_preview },
                  },
                  [_vm._v(" Preview JSON ")]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "bulk-extra",
            fn: function () {
              return [
                _c(
                  "v-btn",
                  {
                    staticClass: "ma-2 white--text",
                    attrs: {
                      "x-small": "",
                      color: "blue",
                      disabled: !_vm.bulkMode || _vm.selected.length === 0,
                    },
                    on: { click: _vm.bulkCopy },
                  },
                  [
                    _vm._v(" Bulk Copy "),
                    _vm.selected.length
                      ? _c("span", [
                          _vm._v(" (" + _vm._s(_vm.selected.length) + ")"),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "item.icon",
            fn: function ({ item }) {
              return [
                _c("v-image-view", {
                  staticStyle: { width: "50px", height: "50px" },
                  attrs: { path: _vm.item_image(item) },
                }),
              ]
            },
          },
          {
            key: "item.actions",
            fn: function ({ item }) {
              return [
                _vm.row_readonly(item)
                  ? _c(
                      "v-icon",
                      {
                        staticClass: "mr-2",
                        attrs: { small: "", color: "green" },
                        on: {
                          click: function ($event) {
                            return _vm.row_view(item)
                          },
                        },
                      },
                      [_vm._v(" mdi-eye ")]
                    )
                  : item.locked
                  ? _c(
                      "v-icon",
                      {
                        staticClass: "mr-2",
                        attrs: { small: "", color: "orange" },
                        on: {
                          click: function ($event) {
                            return _vm.row_update(item)
                          },
                        },
                      },
                      [_vm._v(" mdi-pencil ")]
                    )
                  : _c(
                      "v-icon",
                      {
                        staticClass: "mr-2",
                        attrs: { small: "", color: "green" },
                        on: {
                          click: function ($event) {
                            return _vm.row_update(item)
                          },
                        },
                      },
                      [_vm._v(" mdi-pencil ")]
                    ),
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "", color: "teal lighten-1" },
                    on: {
                      click: function ($event) {
                        return _vm.row_copy(item)
                      },
                    },
                  },
                  [_vm._v(" mdi-content-copy ")]
                ),
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: {
                      disabled: item.global || item.shared,
                      small: "",
                      color: "blue",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.row_export(item)
                      },
                    },
                  },
                  [_vm._v("mdi-briefcase-upload")]
                ),
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: {
                      disabled: item.global || item.shared,
                      small: "",
                      color: "blue",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.row_convert(item)
                      },
                    },
                  },
                  [_vm._v("mdi-cloud-upload-outline")]
                ),
              ]
            },
          },
          {
            key: "no-results",
            fn: function () {
              return [
                _c(
                  "v-alert",
                  { attrs: { value: true, color: "blue-grey", dense: "" } },
                  [
                    _vm._v(
                      ' Your search for "' +
                        _vm._s(_vm.search) +
                        '" found no results. '
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
      _c("r-item-dialog", { ref: "dialog" }),
      _c("r-dialog-preview-collection", { ref: "previewCollection" }),
      _c("r-bulk-copy-dialog", { ref: "bulkCopyDialog" }),
      _c(
        "v-overlay",
        { attrs: { value: _vm.bulkCopyLoading, "z-index": "999" } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }